import { DuctedPairLinkMode } from 'utils/ducted-design-types';

const DUCTED_DESIGN_STEPS = [
  'place each condenser and air handler',
  'give each pair its rooms'
];

const DUCTED_PAIR_LINK_STEP = 'link it to an existing system';

const stepList = new Intl.ListFormat('en', {
  style: 'long',
  type: 'conjunction'
});

function ductedDesignStepsCopy(linkMode: DuctedPairLinkMode): string {
  const steps =
    linkMode === 'manual'
      ? [...DUCTED_DESIGN_STEPS, DUCTED_PAIR_LINK_STEP]
      : DUCTED_DESIGN_STEPS;
  return stepList.format(steps);
}

export function ductedDesignIncompleteReason(
  linkMode: DuctedPairLinkMode
): string {
  return `Finish every ducted system: ${ductedDesignStepsCopy(linkMode)}`;
}

export function ductedDesignPendingChooseSystemsMessage(
  linkMode: DuctedPairLinkMode
): string {
  return `Finish your ducted system design on the System Design page — ${ductedDesignStepsCopy(
    linkMode
  )} — to see compatible systems.`;
}
